import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'je-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.scss']
})
export class ConfirmComponent implements OnInit {

  title: string;
  body: string;
  lowerBody: string;
  ok: string;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: any) { }

  ngOnInit() {
    this.title = this.data.title;
    this.body = this.data.body;
    this.lowerBody = this.data.lowerBody;
    this.ok = this.data.ok ? this.data.ok : 'Ok';
  }
}